import React from 'react';
import { Link, graphql } from 'gatsby';

import TemplateSimple from '../components/templateSimple';
import { handleData } from '../lib/dataHelper';

const Copyright = ({ data }) => {
  const dataToUse = handleData(data) || {};
  const { title, postalAddress, legalStatus, registeredCapital, registrationNumber, vatNumber } = dataToUse;

  return (
    <TemplateSimple pageTitle="Copyright" data={dataToUse}>
      <p>
        L'ensemble des éléments figurant sur ce site sont protégés par les dispositions du Code de la Propriété
        Intellectuelle. En conséquence, toute reproduction de ceux-ci, totale ou partielle, ou imitation fait l'objet de
        toute notre attention et ne peut se faire sans demande préalable écrite.
      </p>
    </TemplateSimple>
  );
};

export const query = graphql`
  query CopyrightQuery($partenaireId: Int!) {
    staticMap {
      ...Map
    }
    strapiPartenaires(strapiId: { eq: $partenaireId }) {
      ...Logo
      ...Contact
      ...Header
      ...Footer
    }
  }
`;

export default Copyright;
